import React, { useState } from "react";
import VerificaToken from "./VerificaToken";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";

function ModalAggiungiPagamento() {
  let history = useHistory();

  const { user, setUser } = VerificaToken();
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const gestisciPagamento = () => {
    axios
      .put(
        `https://website-8bit-motors.herokuapp.com/account/info/${user.id}/rimuoviPagamento`
      )
      .then((response) => {
        axios
          .get(
            `https://website-8bit-motors.herokuapp.com/account/info/${user.id}`
          )
          .then((res) => {
            setShow(false);
            setUser(res.data);
            history.push(`/account/info/${user.id}/aggiungiPagamento`);
          });
      }).catch(() => {
        alert("Connessione Non Disponibile");
      });;
  };

  if (!user.codiceCarta) {
    return (
      <>
        <Link to={`/account/info/${user.id}/aggiungiPagamento`}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-wallet"
            viewBox="0 0 16 16"
          >
            <path d="M0 3a2 2 0 0 1 2-2h13.5a.5.5 0 0 1 0 1H15v2a1 1 0 0 1 1 1v8.5a1.5 1.5 0 0 1-1.5 1.5h-12A2.5 2.5 0 0 1 0 12.5V3zm1 1.732V12.5A1.5 1.5 0 0 0 2.5 14h12a.5.5 0 0 0 .5-.5V5H2a1.99 1.99 0 0 1-1-.268zM1 3a1 1 0 0 0 1 1h12V2H2a1 1 0 0 0-1 1z" />
          </svg>
          <h3>Aggiungi Metodo di Pagamento</h3>
          <p>Clicca qui per inserire un nuovo metodo di pagamento.</p>
        </Link>
      </>
    );
  } else {
    return (
      <>
        <Link onClick={handleShow}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-wallet"
            viewBox="0 0 16 16"
          >
            <path d="M0 3a2 2 0 0 1 2-2h13.5a.5.5 0 0 1 0 1H15v2a1 1 0 0 1 1 1v8.5a1.5 1.5 0 0 1-1.5 1.5h-12A2.5 2.5 0 0 1 0 12.5V3zm1 1.732V12.5A1.5 1.5 0 0 0 2.5 14h12a.5.5 0 0 0 .5-.5V5H2a1.99 1.99 0 0 1-1-.268zM1 3a1 1 0 0 0 1 1h12V2H2a1 1 0 0 0-1 1z" />
          </svg>
          <h3>Aggiungi Metodo di Pagamento</h3>
          <p>Clicca qui per inserire un nuovo metodo di pagamento.</p>
        </Link>

        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Metodo di Pagamento già presente</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Hai già inserito un metodo di pagamento, per inserirne uno nuovo
            rimuovi quello precedente!
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              No grazie.
            </Button>
            <Button variant="primary" onClick={gestisciPagamento}>
              Rimuovi pagamento
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default ModalAggiungiPagamento;
